import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs, Autoplay } from 'swiper/modules';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import { mahalleler } from './Mahalleler';
import './MahalleDetail.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

const MahalleDetail = () => {
  const { urlTag } = useParams();
  const [images, setImages] = useState([]);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const mahalleData = mahalleler.find(m => m.urlTag === urlTag) || {
    name: 'Mahalle bulunamadı',
    image: '',
    totalImages: 0
  };

  useEffect(() => {
    // Generate image array based on totalImages
    const imageArray = Array.from({ length: mahalleData.totalImages }, (_, index) => ({
      src: `/assets/images/mahalleler/${urlTag}/${index + 1}.jpg`,
      alt: `${mahalleData.name} - Fotoğraf ${index + 1}`
    }));
    setImages(imageArray);
  }, [urlTag, mahalleData]);



  return (
    <div className="mahalle-detail-page">
      <div className="container lg-py-5">
        <div className="row xs-mx-0 d-xs-block">

            <QuickMenu />
      
          <div className="col-md-10">
            <h1 className="page-title mb-4">{mahalleData.name}</h1>
            
            <div className="mahalle-gallery">
              <div className="gallery-slider">
                <div className="main-slider mb-3">
                  <Swiper
                    modules={[Navigation, Thumbs, Autoplay]}
                    thumbs={{ swiper: thumbsSwiper }}
                    navigation
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    className="main-swiper"
                    slidesPerView={1}
                    spaceBetween={0}
                  >
                    {images.map((image, index) => (
                      <SwiperSlide key={index} className="slide-item">
                        <img 
                          src={image.src} 
                          alt={image.alt}
                          className="rounded shadow-sm"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className="thumb-slider">
                  <Swiper
                    modules={[Thumbs]}
                    watchSlidesProgress
                    onSwiper={setThumbsSwiper}
                    slidesPerView="auto"
                    spaceBetween={10}
                    className="thumb-swiper"
                    slideToClickedSlide={true}
                    breakpoints={{
                      320: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                      },
                      576: {
                        slidesPerView: 5,
                        spaceBetween: 10,
                      },
                      768: {
                        slidesPerView: 6,
                        spaceBetween: 10,
                      },
                      992: {
                        slidesPerView: 8,
                        spaceBetween: 10,
                      },
                      1200: {
                        slidesPerView: 10,
                        spaceBetween: 10,
                      }
                    }}
                  >
                    {images.map((image, index) => (
                      <SwiperSlide key={index} className="thumb-item">
                        <img 
                          src={image.src} 
                          alt={image.alt}
                          className="rounded"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
    
};

export default MahalleDetail;
